module.exports = __webpack_public_path__ + "static/media/instagram.5d6d2da0.svg";